import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { actionTypes, actions } from "./actions";
import { createTransform } from "redux-persist";

const initialAuthState = {
  user: undefined,
  access: undefined,
  refresh: undefined,
  rememberMe: false,
  expireAt: null,
  isImpersonation: false,
};

const expireTransform = createTransform(
  (inboundState) => {
    // Never persist impersonation sessions — tab close = logged out
    if (inboundState?.isImpersonation) return initialAuthState;
    return inboundState;
  },
  (outboundState) => {
    if (!outboundState) return outboundState;

    const { expireAt, rememberMe } = outboundState;

    if (!rememberMe && expireAt && Date.now() > expireAt) {
      return initialAuthState;
    }

    return outboundState;
  },
  { whitelist: ["auth"] },
);

export const reducer = persistReducer(
  { storage, key: "shine-auth", blacklist: [], transforms: [expireTransform] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { access, refresh, user, rememberMe } = action.payload;

        let expireAt = null;

        if (!rememberMe) {
          const midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          expireAt = midnight.getTime();
        }

        return {
          access,
          refresh,
          user,
          rememberMe,
          expireAt,
        };
      }

      case actionTypes.ImpersonateLogin: {
        const { access } = action.payload;
        return {
          ...initialAuthState,
          access,
          refresh: "",
          isImpersonation: true,
          expireAt: Date.now() + 15 * 60 * 1000,
        };
      }

      case actionTypes.Logout: {
        return initialAuthState;
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.RefreshUser: {
        const { access } = action.payload;
        return { ...state, access };
      }
      default:
        return state;
    }
  },
);
